import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LOGO_URL } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Package, Users, ShoppingBag, LogOut, Home, Settings, Tag } from "lucide-react";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = async () => {
    await logout();
    navigate("/admin-finefood-login");
  };

  const linkCls = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-3 text-sm transition-colors ${
      isActive ? "bg-[#2D6A4F] text-white" : "text-[#4A5D4E] hover:bg-[#F2EFEB]"
    }`;

  return (
    <div className="min-h-screen flex bg-[#F9F8F6]" data-testid="admin-layout">
      <aside className="w-64 bg-white border-r border-[#E5E3DC] flex flex-col">
        <div className="p-6 border-b border-[#E5E3DC]">
          <Link to="/admin" className="flex items-center gap-2">
            <img src={LOGO_URL} alt="FineFood" className="h-10" />
            <div>
              <p className="font-serif text-lg leading-none">FineFood</p>
              <p className="text-xs text-[#E76F51] uppercase tracking-wider">Admin</p>
            </div>
          </Link>
        </div>
        <nav className="flex-1 py-4">
          <NavLink to="/admin" end className={linkCls} data-testid="admin-nav-orders"><ShoppingBag className="w-4 h-4" /> Commandes</NavLink>
          <NavLink to="/admin/products" className={linkCls} data-testid="admin-nav-products"><Package className="w-4 h-4" /> Produits</NavLink>
          <NavLink to="/admin/categories" className={linkCls} data-testid="admin-nav-categories"><Tag className="w-4 h-4" /> Catégories</NavLink>
          <NavLink to="/admin/users" className={linkCls} data-testid="admin-nav-users"><Users className="w-4 h-4" /> Clients</NavLink>
          <NavLink to="/admin/settings" className={linkCls} data-testid="admin-nav-settings"><Settings className="w-4 h-4" /> Paramètres</NavLink>
        </nav>
        <div className="p-4 border-t border-[#E5E3DC]">
          <p className="text-xs text-[#8A9A8E] mb-2">Connecté : {user?.email}</p>
          <Link to="/" className="flex items-center gap-2 text-sm text-[#4A5D4E] hover:text-[#2D6A4F] mb-2" data-testid="admin-back-site">
            <Home className="w-4 h-4" /> Voir le site public
          </Link>
          <button onClick={handleLogout} className="flex items-center gap-2 text-sm text-[#D62828] hover:underline" data-testid="admin-logout">
            <LogOut className="w-4 h-4" /> Déconnexion
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-y-auto p-8">
        <Outlet />
      </main>
    </div>
  );
}
